import React, { useState } from 'react';
import { Tag, Dropdown, Menu, Button } from 'antd';
import { ClientStatus } from 'api/adminApiClient';
import { getClientStatusName } from 'utils/recruiterUtils';

import styles from './ClientStatus.module.less';

type Props = {
  title: string;
  clientStatus?: ClientStatus;
  onStatusChange: (statusId: ClientStatus) => Promise<void>;
};

const availableClientStatuses = [
  ClientStatus.Suspended,
  ClientStatus.Deleted,
  ClientStatus.Terminated,
  ClientStatus.DoNotContact,
  ClientStatus.Declined,
];

export default function ClientStatusComponent(props: Props) {
  const { title, clientStatus, onStatusChange } = props;
  const [loading, setLoading] = useState(false);
  const clientStatusName = getClientStatusName(clientStatus);

  const handleStatusChange = async (status: ClientStatus) => {
    setLoading(true);
    try {
      await onStatusChange(status);
    } finally {
      setLoading(false);
    }
  };

  const clientStatusMenu = (
    <Menu>
      <Menu.ItemGroup title="Change status to:">
        {availableClientStatuses.map((status) => (
          <Menu.Item
            key={String(status)}
            onClick={() => handleStatusChange(status)}
            disabled={status === clientStatus}
          >
            {getClientStatusName(status)}
          </Menu.Item>
        ))}
      </Menu.ItemGroup>
    </Menu>
  );

  return (
    <Tag className={styles.clientStatusTag}>
      {title} <b>{clientStatusName}</b>
      <Dropdown overlay={clientStatusMenu} trigger={['click']}>
        <Button
          type="link"
          size="small"
          icon={<i className="icon icon-edit" />}
          loading={loading}
          onClick={(e) => e.stopPropagation()}
        />
      </Dropdown>
    </Tag>
  );
}
